import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import AlgosignerUtility from "./../apis/AlgosignerUtility";
import Wallet from "./Wallet";
import Button from '@mui/material/Button';
import './Login.css';
import { ToastContainer, toast } from 'react-toastify';
import {MDBContainer, MDBCol, MDBRow, MDBBtn, MDBInput, MDBCheckbox } from 'mdb-react-ui-kit';
var config = require("../../src/config/dev").default;

const isMobile = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const isIOS    = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
const isAndroid= () => /Android/i.test(navigator.userAgent);

const Login = (props) => {
  const [address, setWalletAddress] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPass] = useState("");
  const [enterEmail, setenterEmail] = useState("");
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const handleEmail = (e) => {
    console.log("e",e.target);
    let Email = e.target.value;
    console.log("email",Email);
    setenterEmail(Email);
    console.log("inmailfunction",enterEmail);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(Email)) {
      setEmailError('Invalid Email Format');
      setIsSubmitDisabled(true);
    } else {
      setEmailError('');
      setIsSubmitDisabled(false);
    }
    if(Email == "" || Email == null){
      setEmailError('Please enter Email ID');
      setIsSubmitDisabled(true);
    }
  };

  const handleBlur = () => {
    if (enterEmail.trim() === '') {
      setEmailError('Email is required');
    } else {
      setEmailError('');
    }
  };

  const handleCloseModal = () => {};

  const ForgotPassword = (e) => {
    e.preventDefault();
    document.getElementById("confirmspin").style.display = "block";
    console.log("value",e.target.elements.EmailID.value);
    if(e.target.elements.EmailID.value == "" ||
       e.target.elements.EmailID.value == undefined ||
       e.target.elements.EmailID.value == null) {
      setEmailError('Please Enter Mail ID');
    } else {
      console.log("emailon38",enterEmail);
      const forgot_password = { email: enterEmail };
      console.log(forgot_password);
      if (emailError) { console.log("emailsubmiterr",emailError); return; }
      axios.post(config.API_ENDPOINT+"api/v1/user/forgotpasswordMarketplace", forgot_password)
        .then((response) => {
          console.log("Res",response);
          if (response.data.success == true) {
            document.getElementById("confirmspin").style.display = "block";
            toast.success("Email Sent Successfully!!", {
              position:'top-center', autoClose:3000,
              onClose: () => { window.location.href = config.Local_ENDPOINT+`resetpassword/`+response.data.data.result.otp.userId; }
            });
          } else {
            toast.error("Email ID does not exist!!", { position:'top-center', autoClose:3000 });
          }
        })
        .catch((error) => {
          console.log("err",error);
          const msg = error?.response?.data?.errors?.[0]?.msg || error?.message || "Network error. Please try again.";
          toast.error(msg, { position:'top-center', autoClose:3000, onClose: () => { window.location.reload(); } });
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(email);
    var accessToken;
    const login_user = { email:email, password:password };
    console.log(login_user);
    axios.post(config.API_ENDPOINT+"api/v1/user/signin", login_user)
      .then((response) => {
        document.getElementById("confirmspin").style.display = "block";
        console.log("res", response.data.data);
        accessToken = response.data.data.accessToken;
        sessionStorage.setItem("Id", response.data.data._id);
        if (response.data.data.isVerified == true) {
          document.getElementById("confirmspin").style.display = "block";
          window.location.href = "/home";
          sessionStorage.setItem('traceChainAccessToken', response.data.data.accessToken);
          sessionStorage.setItem("firstName", response.data.data.firstName);
          sessionStorage.setItem("lastName", response.data.data.lastName);
          sessionStorage.setItem("createdAt", response.data.data.createdAt);
          sessionStorage.setItem("email", response.data.data.email);
          sessionStorage.setItem("phoneNumber", response.data.data.phoneNumber);
          sessionStorage.setItem("timeZone", response.data.data.timeZone);
          sessionStorage.setItem("organizationId", response.data.data.reference.organizationId);
          sessionStorage.setItem("affiliateId", response.data.data.reference.affiliateId);
          sessionStorage.setItem("departmentId", response.data.data.reference.departmentId);
          sessionStorage.setItem("LoggedIn", true);
          // MetaMask/AlgoSigner wallet connection disabled — using Hyperledger Fabric, not Ethereum
          // const connectWallet = async () => {
          //   if (typeof window != "undefined" && typeof window.ethereum != "undefined") {
          //     if (isMobile()) {
          //       window.location.href = "https://metamask.app.link/dapp/" + window.location.href;
          //       setTimeout(() => {
          //         if (isIOS()) { window.location.href = "https://apps.apple.com/app/metamask/id1438144202"; }
          //         else if (isAndroid()) { window.location.href = "https://play.google.com/store/apps/details?id=io.metamask"; }
          //       }, 1500);
          //     } else {
          //       try {
          //         const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
          //         setWalletAddress(accounts[0]);
          //       } catch (err) { console.error(err.message); }
          //     }
          //   } else {
          //     if (isMobile()) {
          //       if (isIOS()) { window.location.href = "https://apps.apple.com/app/metamask/id1438144202"; }
          //       else if (isAndroid()) { window.location.href = "https://play.google.com/store/apps/details?id=io.metamask"; }
          //     } else { alert("MetaMask is not installed. Please install it to proceed."); }
          //   }
          // };
          // const buyWithAlgos = async () => {
          //   try {
          //     const connection = await AlgosignerUtility.checkAlgoSignerWallet1(true);
          //     if (!connection) return;
          //   } catch (err) { console.log(err.message); }
          // };
          // connectWallet();
          // buyWithAlgos();
          return accessToken;
        } else {
          toast.error("Invalid Credentials!!", { position:'top-center', autoClose:3000 });
        }
      })
      .catch((error) => {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.message || "Network error. Please try again.";
        toast.error("Error : " + msg, { position:'top-center', autoClose:3000 });
      });
  };

  return (
    <div className="lp-page">

      {/* ══ LEFT — NFT Marketplace branding ══ */}
      <div className="lp-left">

        {/* Brand */}
        <div className="lp-left-brand">
          <span className="lp-left-chain-icon">&#128279;</span>
          <div>
            <div className="lp-left-title">TraceChain</div>
            <div className="lp-left-subtitle">NFT Marketplace</div>
          </div>
        </div>

        {/* Image */}
        <img
          src={require("../images/login_nft.png")}
          className="lp-left-img"
          alt="NFT Marketplace"
        />

        {/* Tagline */}
        <p className="lp-left-tagline">
          Your trusted platform for verified<br />digital asset tokens on blockchain
        </p>

        {/* Info cards */}
        <div className="lp-info-cards">
          <div className="lp-info-card">
            <div className="lp-info-icon">&#127942;</div>
            <div>
              <div className="lp-info-title">Verified Assets</div>
              <div className="lp-info-desc">Every NFT is traceable &amp; blockchain-verified</div>
            </div>
          </div>
          <div className="lp-info-card">
            <div className="lp-info-icon">&#128274;</div>
            <div>
              <div className="lp-info-title">Secure Trading</div>
              <div className="lp-info-desc">Buy &amp; sell tokens with complete security</div>
            </div>
          </div>
          <div className="lp-info-card">
            <div className="lp-info-icon">&#127807;</div>
            <div>
              <div className="lp-info-title">Offset Credits</div>
              <div className="lp-info-desc">Trade EPR plastic &amp; carbon offset credits</div>
            </div>
          </div>
        </div>

      </div>

      {/* ══ RIGHT — Login form ══ */}
      <div className="lp-right">
        <div className="lp-card">

          <div className="lp-card-accent"></div>

          <div className="lp-card-body">
            <h2 className="lp-form-title">Welcome Back</h2>
            <p className="lp-form-sub">Sign in to your Marketplace account</p>

            <form onSubmit={handleSubmit}>

              <div className="lp-field">
                <label className="lp-label" htmlFor="lp-email">Email Address</label>
                <MDBInput
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="you@example.com"
                  id="lp-email"
                  name="email"
                  size="lg"
                  required
                  style={{ fontSize:'14px' }}
                />
              </div>

              <div className="lp-field">
                <label className="lp-label" htmlFor="lp-password">Password</label>
                <MDBInput
                  value={password}
                  onChange={(e) => setPass(e.target.value)}
                  type="password"
                  placeholder="••••••••"
                  id="lp-password"
                  name="password"
                  size="lg"
                  required
                  style={{ fontSize:'14px' }}
                />
              </div>

              <div className="lp-row">
                <MDBCheckbox name='flexCheck' value='' id='flexCheckDefault' label='Remember me' />
                <a data-bs-toggle="modal" data-bs-target="#exampleModal" className="lp-forgot">
                  Forgot Password?
                </a>
              </div>

              <button type="submit" className="lp-submit-btn">LOGIN</button>

            </form>

            <div id="confirmspin" className="loader" style={{ display:"none" }}>Loading...</div>
            <ToastContainer />

            <p className="lp-signup-row">
              Don't have an account?&nbsp;<Link to="/register">Sign Up</Link>
            </p>
          </div>

        </div>
      </div>

      {/* ══ Forgot Password Modal — logic unchanged ══ */}
      <div className="modal" id="exampleModal" tabIndex="-1"
           aria-labelledby="exampleModalLabel" aria-hidden="true" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content" style={{ marginTop:"160px" }}>
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Forgot Password</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form onSubmit={ForgotPassword}>
              <div className="modal-body">
                <div className="form-group">
                  <p>Please enter your email id below to receive an email for resetting your password.</p>
                  <label htmlFor="EmailID">Email ID</label>
                  <input
                    type="email" id="EmailID"
                    onChange={handleEmail}
                    className={`form-control ${emailError ? 'error-input' : ''}`}
                    onBlur={handleBlur}
                  />
                  {emailError && <div className="error-message">{emailError}</div>}
                </div>
              </div>
              <div className="modal-footer">
                <div>
                  <Button type="button" className="buttonclosemodal"
                    data-bs-dismiss="modal" onClick={handleCloseModal}>CANCEL</Button>
                  <Button type="submit"
                    className={`buttonsubmitmodal ${isSubmitDisabled ? 'disabled-button' : ''}`}
                    disabled={isSubmitDisabled}>SUBMIT</Button>
                  <ToastContainer />
                </div>
                <div id="confirmspin" className="loader" style={{ display:"none" }}>Loading...</div>
              </div>
            </form>
            <ToastContainer />
          </div>
        </div>
      </div>

    </div>
  );
};

export default Login;
